import type { CreditScoreSource } from '@makemydeal/dr-platform-types';

export const toCreditScoreSource = (isDealerDefault: boolean): CreditScoreSource =>
    isDealerDefault ? 'dealerDefault' : 'selfReported';
